'use strict';

frontendApp.directive('iioThemePoweredBy', ['$rootScope', 'ThemeService', function ($rootScope, ThemeService) {

  return {
    restrict: 'A',
    scope: false,
    link: function (scope, element, attrs) {

      element.hide();

      scope.theme = ThemeService.getCurrentTheme();
      scope.$on(ThemeService.EVENTS.THEME_CHANGED, function (evt, theme) {
        scope.theme = theme;
      });

      scope.$watch('theme', function (val) {
        if (!_.isEmpty(val)) {
          // Only white-label tenants get the attribution. Tenant themes come
          // from the API and carry no firstParty flag.
          if (val['firstParty']) {
            element.hide();
          } else {
            element.show();
          }
        }
      });

    }
  }

}]);
